// extracted by mini-css-extract-plugin
export default {"tableWrapper":"StreetsTypesPage_tableWrapper__heOgI","oddRow":"StreetsTypesPage_oddRow__gOwWW"};